import { render, staticRenderFns } from "./BuildingChips.vue?vue&type=template&id=b4732d42&scoped=true"
import script from "./BuildingChips.vue?vue&type=script&lang=js"
export * from "./BuildingChips.vue?vue&type=script&lang=js"
import style0 from "./BuildingChips.vue?vue&type=style&index=0&id=b4732d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4732d42",
  null
  
)

export default component.exports